export default {
  // Common
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    loading: 'Loading...',
    loadMore: 'Load More',
    noMore: 'No More',
    retry: 'Retry',
    back: 'Back',
    next: 'Next',
    prev: 'Previous',
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    refresh: 'Refresh',
    complete: 'Complete',
    skip: 'Skip'
  },
  
  // Navigation
  nav: {
    discover: 'Home',
    message: 'Message',
    store: 'Store',
    mine: 'Mine',
  },
  
  // Home
  home: {
    title: 'Roleplay World',
    subtitle: 'Start Your Story',
    startGame: 'Start Game',
    continueGame: 'Continue',
    newGame: 'New Game',
    gameLibrary: 'Library',
    featured: 'Featured',
    popular: 'Popular',
    recent: 'Recent',
    search: 'Search for roles...',
    noData: 'No Data',
    noMoreData: 'No more data'
  },
  
  // User
  user: {
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    profile: 'Profile',
    avatar: 'Avatar',
    nickname: 'Nickname',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    forgotPassword: 'Forgot Password',
    changePassword: 'Change Password',
    bindPhone: 'Bind Phone',
    verifyCode: 'Verify Code',
    sendCode: 'Send Code',
    level: 'Level',
    experience: 'Experience',
    achievement: 'Achievement',
    history: 'History'
  },
  
  // Game
  game: {
    character: 'Character',
    story: 'Story',
    chapter: 'Chapter',
    scene: 'Scene',
    dialogue: 'Dialogue',
    choice: 'Choice',
    inventory: 'Inventory',
    achievement: 'Achievement',
    save: 'Save Game',
    load: 'Load Game',
    restart: 'Restart',
    pause: 'Pause',
    resume: 'Resume',
    auto: 'Auto',
    speed: 'Speed',
    volume: 'Volume',
    settings: 'Game Settings'
  },
  
  // Messages
  message: {
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    networkError: 'Network Error',
    serverError: 'Server Error',
    loginSuccess: 'Registration successful',
    loginFailed: 'Registration failed',
    logoutSuccess: 'Logout Success',
    saveSuccess: 'Save Success',
    saveFailed: 'Save Failed',
    deleteConfirm: 'Confirm Delete?',
    operationConfirm: 'Confirm Operation?',
    noNewsYet: 'No news yet',
    deleteSuccess: 'Delete Success',
    deleteFailed: 'Delete Failed',
    deleteMessage: 'Are you sure you want to delete this message? Once the operation is completed, it cannot be undone!',
    delete: 'Delete',
    deleting: 'Deleting...',
    noMoreData: 'No more messages',
    downloading: 'Downloading...',
    downloadSuccess: 'Download Success',
    downloadFailed: 'Download Failed',
    copySuccess: 'Copy Success',
    copyFailed: 'Copy Failed',
    reportSuccess: 'Report Success',
    reportFailed: 'Report Failed',
    translating: 'Translating...',
    translateSuccess: 'Translation Success',
    translateFailed: 'Translation Failed',
    noMoreMessages: 'No more messages',
    loading_more: 'Loading more...',
    chat_placeholder: 'Type what you want to say...',
    setAsBackdropConfirm: 'Set as backdrop',
    setAsBackdropMessage: 'Are you sure you want to set this image as backdrop?',
  },
  // success
  success:{
    refreshSuccess: 'Refresh Success',
  },
  // Error
  error: {
    notFound: 'Page Not Found',
    networkError: 'Network Error',
    serverError: 'Server Error',
    permissionDenied: 'Permission Denied',
    goHome: 'Go Home',
    tryAgain: 'Try Again'
  },

  // 404 Page
  notFound: {
    title: 'Page Not Found',
    description: 'The page you are looking for does not exist or has been moved.',
    goHome: 'Go Home',
    goBack: 'Go Back'
  },

  
  // Settings
  settings: {
    language: 'Language',
    theme: 'Theme',
    notification: 'Notification',
    privacy: 'Privacy',
    security: 'Security',
    about: 'About',
    version: 'Version',
    checkUpdate: 'Check Update',
    clearCache: 'Clear Cache',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy'
  },

  // Login
  login: {
    title: 'Bind email',
    subtitle: 'Please bind your email to ensure the security of your account data.',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    signUp: 'Sign up',
    signInWithGoogle: 'Sign in with Google',
    signInWithEmail: 'Sign in with Email',
    signInWithPhone: 'Sign in with Phone',
    signInWithFacebook: 'Sign in with Facebook',
    signInWithTwitter: 'Sign in with Twitter',
    signInWithApple: 'Sign in with Apple',
    signInWithMicrosoft: 'Sign in with Microsoft',
    signInWithYahoo: 'Sign in with Yahoo',
    signInWithLinkedin: 'Sign in with Linkedin',
    signInWithInstagram: 'Sign in with Instagram',
    signInWithTiktok: 'Sign in with Tiktok',
    signInWithSnapchat: 'Sign in with Snapchat',
    signInWithPinterest: 'Sign in with Pinterest',
    signInWithReddit: 'Sign in with Reddit',
    signInWithDiscord: 'Sign in with Discord',
    signInWithTwitch: 'Sign in with Twitch',
    signInWithYoutube: 'Sign in with Youtube',
    signInWithSoundcloud: 'Sign in with Soundcloud',
    signInWithSpotify: 'Sign in with Spotify',
    signInWithAmazon: 'Sign in with Amazon',
    signInWithEbay: 'Sign in with Ebay',
    signInWithPaypal: 'Sign in with Paypal',
    signInWithStripe: 'Sign in with Stripe',
    dontHaveAccount: 'Don\'t have an account yet?',
    register: 'Register',
    bySigningUp: 'By signing up, you agree to',
    userAgreement: 'User Agreement &',
    privacyPolicy: 'Privacy Policy.',
    guestMode: 'Guest Mode',
    registerTitle: 'Registration starts',
    registerSubtitle: 'Please bind your email to ensure the security of your account data.',
    alreadyHaveAccount: 'Already have an account?',
    pleaseInputPasswordAndEmail: 'Please input password and email',
    pleaseInputCorrectEmail: 'Please input correct email',
    pleaseInputCorrectPassword: 'Password must be between 6-30 characters',
    male: 'Male',
    female: 'Female',
    neutral: 'Neutral',
    loggingIn: 'Loading in...',
    loading: 'Loading...',
    releaseToRefresh: 'Release to refresh',
    loginFailed: 'Login Failed',
    loginSuccess: 'Registration successful',
    registerFailed: 'Register Failed',
    registerSuccess: 'Register Success',
  }
}
